import type { AxiosInstance } from 'axios';
import { normalizeAxiosError } from '../utils/apiError';

// Core Mpesa API functions (raw HTTP only)
const getUnapprovedMpesaPaymentsCore = async (
  axiosinstance: AxiosInstance,
  page: number,
  limit: number,
  auth: { accessToken?: string | null },
) => {
  return axiosinstance.get(
    `bp_get_unapproved_mpesa_payments_made_information?page=${page}&limit=${limit}`,
    {
      headers: { Authorization: 'Bearer ' + String(auth?.accessToken || '') },
    },
  );
};

const makeMpesaStkPushCore = async (
  axiosinstance: AxiosInstance,
  payload: { bp_order_id: string; bp_phone_number: string },
  auth: { accessToken?: string | null },
) => {
  return axiosinstance.post(
    `bp_make_mpesa_stk_push_payment_information`,
    JSON.stringify(payload),
    {
      headers: { Authorization: 'Bearer ' + String(auth?.accessToken || '') },
    },
  );
};

const checkMpesaPaymentsByPhoneCore = async (
  axiosinstance: AxiosInstance,
  payload: { bp_phone_number: string; bp_order_id: string },
  auth: { accessToken?: string | null },
) => {
  return axiosinstance.post(
    `bp_check_mpesa_payments_information_currently_made_by_phone_number`,
    JSON.stringify(payload),
    {
      headers: { Authorization: 'Bearer ' + String(auth?.accessToken || '') },
    },
  );
};

const getMpesaConfigurationInformationCore = async (
  axiosinstance: AxiosInstance,
  auth: { accessToken?: string | null },
) => {
  return axiosinstance.get(`/bp_employee_get_mpesa_configuration_information`, {
    headers: { Authorization: 'Bearer ' + String(auth?.accessToken || '') },
  });
};

// Public wrappers
export const getUnapprovedMpesaPayments = async (
  axiosinstance: AxiosInstance,
  page: number,
  limit: number,
  auth: { accessToken?: string | null },
) => {
  try {
    return await getUnapprovedMpesaPaymentsCore(
      axiosinstance,
      page,
      limit,
      auth,
    );
  } catch (e: unknown) {
    return Promise.reject(normalizeAxiosError(e));
  }
};

export const makeMpesaStkPush = async (
  axiosinstance: AxiosInstance,
  payload: { bp_order_id: string; bp_phone_number: string },
  auth: { accessToken?: string | null },
) => {
  try {
    return await makeMpesaStkPushCore(axiosinstance, payload, auth);
  } catch (e: unknown) {
    return Promise.reject(normalizeAxiosError(e));
  }
};

export const checkMpesaPaymentsByPhone = async (
  axiosinstance: AxiosInstance,
  payload: { bp_phone_number: string; bp_order_id: string },
  auth: { accessToken?: string | null },
) => {
  try {
    return await checkMpesaPaymentsByPhoneCore(axiosinstance, payload, auth);
  } catch (e: unknown) {
    return Promise.reject(normalizeAxiosError(e));
  }
};

export const getMpesaConfigurationInformation = async (
  axiosinstance: AxiosInstance,
  auth: { accessToken?: string | null },
) => {
  try {
    return await getMpesaConfigurationInformationCore(axiosinstance, auth);
  } catch (e: unknown) {
    return Promise.reject(normalizeAxiosError(e));
  }
};
